// extracted by mini-css-extract-plugin
module.exports = {"main":"CommonError_main__2mBUH","errorTooltip":"CommonError_errorTooltip__B6Yve"};